<template>
    <Stepper ref="stepper" :steps="steps">
        <template #pasoCero="{ changeStep }">
            <BuscarBaseComponent
                :front="false"
                id="paso-0"
                :base="base_search"
                :error="error"
                @terminado="() => buscarBase(changeStep)"
            />
        </template>

        <template #pasoUno="{ changeStep }">
            <PasoUnoComponent
                id="paso-1"
                :paso_activo="true"
                :base="base"
                :esMovil="esMovil"
                :active="true"
                @terminado="changeStep"
                @volver="() => changeStep(true)"
                @guardarBase="guardarBase"
            />
        </template>

        <template #pasoDos="{ changeStep }">
            <PasoDosComponent
                id="paso-2"
                :paso_activo="true"
                :base="base"
                :esMovil="esMovil"
                @terminado="changeStep"
                @volver="() => changeStep(true)"
                @guardarBase="guardarBase"
            />
        </template>

        <template #pasoTres="{ changeStep }">
            <PasoTresComponent
                v-if="base.categoria_base && base.categoria_base.tiene_indumentarias"
                id="paso-3"
                :paso_activo="true"
                :base="base"
                :esMovil="esMovil"
                :indumentarias-seleccionadas="base.categoria_base.indumentariasElegidas"
                @terminado="(data) => {
                    guardarBase(data);
                    changeStep();
                }"
                @volver="() => changeStep(true)"
                :key="reloadComponent"
            />
        </template>

        <template #pasoCuatro="{ changeStep }">
            <PasoCuatroComponent
                id="paso-4"
                :paso_activo="true"
                :base="base"
                :esMovil="esMovil"
                @terminado="changeStep"
                @volver="() => changeStep(true)"
            />
        </template>

        <template #pasoCinco="{changeStep}">
            <PasoCincoComponent
                id="paso-5"
                :base="base"
                :esMovil="esMovil"
                @volver="() => changeStep(true)"
            />
        </template>
    </Stepper>
</template>

<script>
    import BuscarBaseComponent from "@/components/frontend/bases/renovar/BuscarBaseComponent.vue";
    import Stepper from "@/components/frontend/events/compra/components/Stepper";
    import PasoUnoComponent from "@/components/backend/bases/components/PasoUnoComponent";
    import PasoDosComponent from "@/components/backend/bases/components/PasoDosComponent";
    import PasoTresComponent from "@/components/backend/bases/components/PasoTresComponent";
    import PasoCuatroComponent from "@/components/backend/bases/components/PasoCuatroComponent";
    import PasoCincoComponent from "@/components/backend/bases/components/PasoSeisComponent";

    export default {
        data() {
            return {
                base_search: {
                    dni: null,
                },
                base: null,
                error: false,
                loading: false,
                esMovil: false,
                reloadComponent: 0
            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            steps() {
                const baseSteps = [
                    { label: "Buscar base", slot: "pasoCero" },
                    { label: "Datos personales", slot: "pasoUno" },
                    { label: "Datos responsables", slot: "pasoDos" },
                ];

                if (this.base && this.base.categoria_base && this.base.categoria_base.tiene_indumentarias) {
                    baseSteps.push({ label: "Indumentarias", slot: "pasoTres" });
                }

                baseSteps.push(
                    { label: "Descuentos", slot: "pasoCuatro" },
                    { label: "Confirmación", slot: "pasoCinco" }
                );

                return baseSteps;
            }
        },
        methods: {
            buscarBase(changeStep) {
                this.loading = true;

                const params = {
                    filters: {
                        tid: this.configuracion.hash_teatro,
                        dni: this.base_search.dni
                    },
                }

                this.$store.dispatch(this.config.getVuexAlias('front.bases.buscar'), params).then(res => {
                    this.base = res.data.base;
                    this.error = false;
                    changeStep();
                }).catch(error => {
                    this.error = error.response.data.message;
                }).finally(() => this.loading = false);
            },
            guardarBase(base) {
                this.base = { ...base };
            },
            volverPasoCero() {
                this.base = null;
                this.error = null;
                this.base_search.dni = null;
                this.$refs.stepper.goToStep(0);
            },
            onResize() {
                this.esMovil = window.innerWidth < 768
            },
        },
        beforeDestroy() {
            if (typeof window !== 'undefined') {
                window.removeEventListener('resize', this.onResize, { passive: true })
            }
        },
        mounted() {
            this.onResize()
            window.addEventListener('resize', this.onResize, { passive: true })
        },
        components: {
            BuscarBaseComponent,
            Stepper,
            PasoUnoComponent,
            PasoDosComponent,
            PasoTresComponent,
            PasoCuatroComponent,
            PasoCincoComponent
        }
    }
</script>
